const Footer = () => {
  return (
    <header className='flex flex-row'>
      <div className="flex-1 bg-blue-300 text-center rounded-md text-white p-2 m-2">
        Socket Cam (RC 4.2) © 2022 - hirosuke-pi
      </div>
    </header>
  );
}

export default Footer;
  